import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { IconButtonComponent, IconComponent } from '../../base';
import * as deTranslations from '../assets/i18n/de-lang.json';
import * as enTranslations from '../assets/i18n/en-lang.json';

@Component({
  selector: 'spx-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss'],
  imports: [CommonModule, MatProgressBarModule, TranslateModule, FlexLayoutModule, IconComponent, IconButtonComponent],
})
export class ProgressBarComponent implements OnInit {
  @Input() title!: string;
  @Input() unit!: string;
  @Input() error: string | null = null;
  @Input() current!: number;
  @Input() total?: number;

  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() cancel = new EventEmitter<void>();

  public cancelable = false;

  constructor(private translate: TranslateService) {
    this.translate.setTranslation('en', enTranslations, true);
    this.translate.setTranslation('de', deTranslations, true);
  }

  ngOnInit() {
    this.cancelable = this.cancel.observed;
  }

  public isIndeterminate() {
    return !this.total;
  }

  public getPercent(): number | undefined {
    if (this.total) {
      return (this.current / this.total) * 100;
    }
    return undefined;
  }

  public isFinished(): boolean {
    const percentage = this.getPercent();
    return percentage && percentage >= 100 ? true : false;
  }

  public cancelProgress() {
    this.cancel.emit();
  }
}
